import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';

const firebaseConfig = {
  apiKey: "",
  authDomain: "",
  databaseURL: "",
  projectId: "",
  storageBucket: "",
  messagingSenderId: "",
  appId: "",
  measurementId: "e"
};

// Verifica se o app já foi inicializado para evitar erros no Hot Reload do React
const app = !firebase.apps.length ? firebase.initializeApp(firebaseConfig) : firebase.app();

// Aqui exportamos o db usando a sintaxe de compatibilidade
export const db = app.firestore();